import type { TFlagsRecord } from '@feathr/blackbox';

/**
 * Whether the new imports UI is on. It needs both `showImportRunDetails` and `importOrchestrator`;
 * with only one of them on, every imports screen behaves as with neither.
 *
 * Takes a plain flags record, so it reads `useFlags()` as well as a merged account and user
 * `flags` record.
 */
export function isImportsRevampEnabled(flags: Partial<TFlagsRecord>): boolean {
  return Boolean(flags.showImportRunDetails && flags.importOrchestrator);
}
